import { Box } from '@chakra-ui/react'
import { Button } from 'uikit'
import { useBoolean } from 'react-use'
import { Modal, Select } from 'uikit'
import { useState } from 'react'
import { identificationOptions } from './ChangeUserIdentification.constants'
import { useChangeUserIdentification } from './services/useChangeUserIdentification'

export const ChangeUserIdentification = ({ initialValues = {}, userId, disabled }) => {
  const initialState = { identification: initialValues.identification }

  const { mutate, isLoading } = useChangeUserIdentification(userId)
  const [isOpen, setOpenModal] = useBoolean(false)
  const [values, setValues] = useState(initialState)

  const onChange = (value) => {
    setValues((state) => ({ ...state, ...value }))
  }

  const handleSubmit = () => {
    mutate(values)
    setOpenModal(false)
  }

  const onClose = () => {
    setValues(initialState)
    setOpenModal(false)
  }

  return (
    <>
      <Button
        width="100%"
        onClick={() => setOpenModal(true)}
        colorPalette="gray"
        loading={isLoading}
        disabled={disabled}
      >
        Изменить
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} title="Изменить идентификацию">
        <Select
          name="identification"
          label="Статус"
          isSearchable={false}
          placeholder="Выберите"
          value={values.identification}
          options={identificationOptions}
          onChange={(event) => onChange({ identification: event.value })}
        />
        <Box pt={12}>
          <Button colorPalette="orange" loading={isLoading} onClick={handleSubmit}>
            Продолжить
          </Button>
        </Box>
      </Modal>
    </>
  )
}
